import { create } from 'zustand'

export type AppStateStatus = 'intake' | 'pending' | 'error' | 'complete'
export type AppState = {
  status: AppStateStatus
}
export type AppStore = AppState & {
  setStatus: (status: AppStateStatus) => void
}

function getInitialStatus(): AppStateStatus {
  const submissionId = localStorage?.getItem('submissionId')
  return !submissionId ? 'intake' : 'pending'
}

export const useAppState = create<AppStore>((set) => ({
  status: getInitialStatus(),
  setStatus: (status) => set({ status }),
}))
